import { ReceiptService } from "../../../api/receipt.service";

export interface CancellationFeeResponse {
  cancellationFee: number;
}

export const useCancellationFeeHandler = () => {
  const receiptService = new ReceiptService();

  const getCancellationFee = async (txId: string): Promise<CancellationFeeResponse> => {
    try {
      const response = await receiptService.getCancellationFee(txId);
      return response.data;
    } catch (error) {
      console.error('Error fetching cancellation fee:', error);
      throw error;
    }
  };

  return {
    getCancellationFee,
  };
};